import type { ReactNode } from "react";
import LoadingLabel from "./LoadingLabel";

export interface FormActionsProps {
  /** Submit button text, e.g. "Save budget". */
  label: string;
  busy?: boolean;
  disabled?: boolean;
  busyLabel?: string;
  /** Optional quiet link under the submit button: red for destructive actions (Delete); add `form-actions-muted` for neutral ones. */
  secondary?: ReactNode;
}

/**
 * The one footer every add/edit modal uses: a full-width submit button, nothing beside it.
 * Cancelling is the modal's own close button (or tapping outside / Esc), so forms never add one.
 */
export default function FormActions({ label, busy = false, disabled = false, busyLabel = "Saving", secondary }: FormActionsProps) {
  return (
    <div className="form-actions">
      <button type="submit" className="primary-button" disabled={busy || disabled}>
        {busy ? <LoadingLabel>{busyLabel}</LoadingLabel> : label}
      </button>
      {secondary && <div className="form-actions-secondary">{secondary}</div>}
    </div>
  );
}
